import uuid from 'uuid/v1';
import Amplify, { Auth } from 'aws-amplify';
import S3 from 'aws-sdk/clients/s3'; // Importe o S3 da v2
import { Storage } from 'aws-amplify';

import config from '../config/aws';

// Helper para obter a extensão, pode manter a sua.
function ext(filename) {
  return filename.split('.').pop();
}

export async function fileUploadMedia(fileType, fileId, file, fncProgress) {
  const filename = `${fileId}---${Date.now()}.${ext(file.name)}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: "public",
    contentType: file.type,
    bucket: fileType === 'film' ? config.S3_MEDIA_FILM.BUCKET : config.S3_MUSIC.BUCKET,
    progressCallback(progress) {
      console.log(`# Uploaded: ${progress.loaded}/${progress.total}`);
      let varControl = (progress.loaded * 100) / progress.total;
      let strControl = varControl.toFixed(2);
      console.log(`# Uploaded: ${strControl} %`);
      fncProgress(parseFloat(strControl));
    }
  });

  let link = `${fileType === 'film' ? config.S3_MEDIA_FILM.CLOUD_FRONT : config.S3_MUSIC.CLOUD_FRONT}/`;
  link += filename;

  // console.log(link);

  // const link = await Storage.get(stored.key);
  // console.log(link);
  // const link = `https://${config[S3_MEDIA_FILM.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, filename, link };
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export async function fileUploadImg(fileType, fileId, fileSize, file) {
  const filename = `${fileId}---${fileSize}---${Date.now()}.${ext(file.name)}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config[`S3_THUMBNAILS_${fileType.toUpperCase()}`].BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);

  // Link normal
  // const link = `https://${config[`S3_THUMBNAILS_${fileType.toUpperCase()}`].BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  // Link CDN
  const link = `https://cdn.${fileType.toLowerCase()}.hkn-pro.com/${
    stored.key
  }`;

  return { key: stored.key, link };
}

export async function fileUploadInfluencerImg(fileId, fileType, file) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_INFLUENCER.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_INFLUENCER.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadCatalogImg(fileId, fileType, file) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_CATALOG.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_CATALOG.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadCategoryImg(fileId, fileType, file) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_CATEGORY.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_CATEGORY.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadLabelImg(fileId, fileType, file) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_LABEL.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_LABEL.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadArtistImg(fileId, fileType, file) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_ARTIST.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_ARTIST.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadAlbumImg(fileId, fileType, file) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_ALBUM.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_ALBUM.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadSong(fileId, fileType, file, fncProgress) {
  const filename = `${fileId}---${fileType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_SONG.BUCKET,
    progressCallback(progress) {
      console.log(`# Uploaded: ${progress.loaded}/${progress.total}`);
      const varControl = (progress.loaded * 100) / progress.total;
      const strControl = varControl.toFixed(2);
      console.log(`# Uploaded: ${strControl} %`);
      fncProgress(parseFloat(strControl));
    },
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_SONG.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function s3Upload(file) {
  const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    // level: 'public',
    contentType: file.type,
  });
  console.log(stored);

  // const get = await Storage.get(stored);
  // console.log(get);

  return stored.key;
}
export async function fileRead(key) {
  const link = await Storage.get(key);
  // console.log(link);
  return link;
}

export async function fileUploadMediaImg(medId, medType, file) {
  const filename = `${medId}---${medType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAIL.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAIL.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadMediaImgRead(key) {
  const link = await Storage.get(key);
  // console.log(link);
  return link;
}

export async function fileUploadMediaMovie(chaId, medId, file, fncProgress) {
  const filename = `${chaId}---${medId}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_MOVIE.BUCKET,
    progressCallback(progress) {
      console.log(`# Uploaded: ${progress.loaded}/${progress.total}`);
      const varControl = (progress.loaded * 100) / progress.total;
      const strControl = varControl.toFixed(2);
      console.log(`# Uploaded: ${strControl} %`);
      fncProgress(parseFloat(strControl));
    },
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  // const link = `https://${config.S3_MOVIE.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, filename };
}

export async function fileUploadMediaMovieRead(key) {
  const link = await Storage.get(key);
  // console.log(link);
  return link;
}

export async function fileUploadChannelImg(chaId, medType, file) {
  const filename = `${chaId}---${medType}---${Date.now()}.${ext(file.name)}`;
  // const filename = `${Date.now()}-${uuid()}`;

  // const stored = await Storage.vault.put(filename, file, {
  // private s3 "vault"
  const stored = await Storage.put(filename, file, {
    level: 'public',
    contentType: file.type,
    bucket: config.S3_THUMBNAILS_PROFILES.BUCKET,
  });

  // const link = await Storage.get(stored.key);
  // console.log(link);
  const link = `https://${config.S3_THUMBNAILS_PROFILES.BUCKET}.s3.amazonaws.com/public/${stored.key}`;

  return { key: stored.key, link };
}

export async function fileUploadChannelImgRead(key) {
  const link = await Storage.get(key);
  // console.log(link);
  return link;
}


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// melhor mas precisa atualizar react
// import uuid from 'uuid/v1';
// import { Auth } from 'aws-amplify';
// import {
//   S3Client,
//   CreateMultipartUploadCommand,
//   UploadPartCommand,
//   CompleteMultipartUploadCommand,
//   AbortMultipartUploadCommand,
// } from '@aws-sdk/client-s3';
// import config from '../config/aws';

// // Helper para obter a extensão, pode manter a sua.
// function ext(filename) {
//   return filename.split('.').pop();
// }

// export async function fileUploadMedia(fileType, fileId, file, fncProgress) {

//   // 1. --- Configuração Inicial ---
//   const filename = `${fileId}---${Date.now()}.${ext(file.name)}`;
//   const bucket = fileType === 'film' ? config.S3_MEDIA_FILM.BUCKET : config.S3_MUSIC.BUCKET;

//   // O tamanho da parte é crucial. 10MB é um bom começo.
//   // O S3 exige que as partes tenham no mínimo 5MB (exceto a última).
//   const chunkSize = 10 * 1024 * 1024; // 10MB
//   const totalChunks = Math.ceil(file.size / chunkSize);

//   // 2. --- Obter Credenciais e Criar Cliente S3 ---
//   // Obtém as credenciais iniciais. Elas serão renovadas para cada parte se necessário.
//   const credentials = await Auth.currentCredentials();
//   const s3Client = new S3Client({
//     region: config.S3_MEDIA_FILM.REGION, // ou sua região
//     credentials: {
//       accessKeyId: credentials.accessKeyId,
//       secretAccessKey: credentials.secretAccessKey,
//       sessionToken: credentials.sessionToken,
//     },
//   });

//   let uploadId;

//   try {
//     // 3. --- Iniciar o Multipart Upload ---
//     console.log('Iniciando Multipart Upload...');
//     const createUploadParams = {
//       Bucket: bucket,
//       Key: filename,
//       ContentType: file.type,
//     };
//     const multipartUpload = await s3Client.send(new CreateMultipartUploadCommand(createUploadParams));
//     uploadId = multipartUpload.UploadId;
//     console.log(`Upload ID: ${uploadId}`);

//     // 4. --- Fazer Upload de Cada Parte ---
//     const uploadedParts = [];
//     for (let i = 0; i < totalChunks; i++) {
//       const start = i * chunkSize;
//       const end = start + chunkSize;
//       const chunk = file.slice(start, end);
//       const partNumber = i + 1;

//       console.log(`Fazendo upload da parte ${partNumber}/${totalChunks}`);

//       // O SDK renova as credenciais automaticamente se expirarem entre os comandos.
//       // Você também pode forçar a renovação aqui se quiser ter certeza absoluta:
//       // const freshCredentials = await Auth.currentCredentials();
//       // s3Client.config.credentials = freshCredentials;

//       const uploadPartParams = {
//         Bucket: bucket,
//         Key: filename,
//         UploadId: uploadId,
//         PartNumber: partNumber,
//         Body: chunk,
//       };

//       const partResult = await s3Client.send(new UploadPartCommand(uploadPartParams));

//       uploadedParts.push({
//         PartNumber: partNumber,
//         ETag: partResult.ETag,
//       });

//       // Atualiza o progresso
//       const progress = ((i + 1) / totalChunks) * 100;
//       fncProgress(parseFloat(progress.toFixed(2)));
//     }

//     // 5. --- Completar o Upload ---
//     console.log('Completando o Multipart Upload...');
//     const completeParams = {
//       Bucket: bucket,
//       Key: filename,
//       UploadId: uploadId,
//       MultipartUpload: {
//         Parts: uploadedParts,
//       },
//     };

//     await s3Client.send(new CompleteMultipartUploadCommand(completeParams));

//     // 6. --- Retornar o resultado final ---
//     let link = `${fileType === 'film' ? config.S3_MEDIA_FILM.CLOUD_FRONT : config.S3_MUSIC.CLOUD_FRONT}/`;
//     link += filename;

//     console.log('Upload concluído com sucesso!');
//     return { key: filename, filename, link };

//   } catch (error) {
//     console.error('Erro durante o Multipart Upload:', error);

//     // 7. --- Abortar em caso de erro ---
//     if (uploadId) {
//       console.log('Abortando o upload...');
//       await s3Client.send(new AbortMultipartUploadCommand({
//         Bucket: bucket,
//         Key: filename,
//         UploadId: uploadId,
//       }));
//       console.log('Upload abortado.');
//     }

//     throw error;
//   }
// }
